module.exports = __webpack_public_path__ + "img/class_raytracer.ec80e2c8.png";